import { createContext } from "react";

import { UserInfo } from "@/typings";

const UserInfoContext = createContext<{
  userInfo?: UserInfo;
  setUserInfo: (data?: UserInfo) => void;
}>({
  userInfo: undefined,
  setUserInfo: () => {
    //
  },
});

export default UserInfoContext;
